import { render, staticRenderFns } from "./confirmation-popup.vue?vue&type=template&id=a7279c58&scoped=true"
import script from "./confirmation-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirmation-popup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./confirmation-popup.vue?vue&type=style&index=0&id=a7279c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7279c58",
  null
  
)

export default component.exports